/* eslint-disable no-unused-vars*/
import React from 'react';
import { HasAccess } from '@permify/react-role';
import { Space, Table, Tag, Tooltip } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { deleteVideoTutorial } from 'api/videoTutorial';
import { ButtonPrimary } from 'common/Button/Button.styles';
import Swal from 'sweetalert2';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import { getCookie } from 'helper/cookie';
import Color from 'constants/color';
import DOMPurify from 'dompurify';
import styled from 'styled-components';

const TableVideoTutorial = (props: any) => {
  const { isLoading, data, renderData, pagination, onChangePage, navigate, token } = props;

  const isMobileView = useSelector(state => get(state, 'device.isMobileView', false));
  const widthMobile = getCookie('widthMobile');

  const deleteData = async (id: any) => {
    Swal.fire({
      title: 'คุณแน่ใจว่าจะลบข้อมูลนี้',
      text: 'หากคุณลบแล้วจะไม่แสดงข้อมูลนี้',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: Color.primaryClick,
      // cancelButtonColor: '#d33',
      cancelButtonText: 'ยกเลิก',
      confirmButtonText: 'ต้องการลบข้อมูล',
      reverseButtons: true,
    }).then(async result => {
      if (result.isConfirmed) {
        const deleteData = await deleteVideoTutorial({ token: token, id });
        const { status, error, message } = deleteData;
        if (status === 200) {
          Swal.fire({
            title: 'Successful',
            text: 'Delete Success',
            icon: 'success',
            confirmButtonText: 'Close',
            showConfirmButton: false,
          });
          renderData(pagination);
        } else {
          Swal.fire({
            title: message,
            text: 'ไม่สามารถลบข้อมูลนี้ได้',
            icon: 'error',
            showConfirmButton: false,
            confirmButtonText: 'Close',
            showClass: {
              popup: 'animate__animated animate__fadeInDown',
            },
            hideClass: {
              popup: 'animate__animated animate__fadeOutUp',
            },
          });
        }
      }
    });
  };

  const columns: any = [
    {
      title: 'รหัส',
      dataIndex: 'id',
      key: 'id',
      align: 'center',
      width: 70,
    },
    {
      title: 'ลำดับ',
      dataIndex: 'video_tutorial_sort',
      key: 'video_tutorial_sort',
      align: 'center',
      width: 70,
      // responsive: ['sm'],
    },
    {
      title: 'หมวดหมู่วีดีโอ',
      // dataIndex: 'category_id',
      key: 'category_tutorial_id',
      align: 'center',
      width: 150,
      render: (data: any) => {
        return <span>{data?.category_tutorial_data?.category_tutorial_name}</span>;
      },
      // responsive: ['sm'],
    },
    {
      title: 'ชื่อวีดีโอ',
      dataIndex: 'video_tutorial_name',
      key: 'video_tutorial_name',
      align: 'center',
      width: 150,
      // responsive: ['sm'],
    },
    {
      title: 'รายละเอียด',
      // dataIndex: 'video_tutorial_detail',
      key: 'video_tutorial_detail',
      align: 'center',
      width: 150,
      render: (data: any) => {
        const sanitizedHTML = data?.video_tutorial_detail; //DOMPurify.sanitize();
        return (
          <VideoContainer>
            <div dangerouslySetInnerHTML={{ __html: sanitizedHTML }} />
          </VideoContainer>
        );
      },
      // responsive: ['sm'],
    },
    {
      title: 'สถานะ',
      dataIndex: 'video_tutorial_status',
      key: 'video_tutorial_status',
      align: 'center',
      width: 100,
      render: (data: any) => {
        return (
          <Tag
            color={data === 'Y' ? 'green' : 'red'}
            style={{
              width: '100%',
              textTransform: 'capitalize',
              textAlign: 'center',
            }}
          >
            {data === 'Y' ? 'active' : 'Inactive'}
          </Tag>
        );
      },
      // responsive: ['sm'],
    },
    {
      title: 'Action',
      align: 'center',
      width: 120,
      render: (data: any) => {
        return (
          <Space size={8}>
            <HasAccess
              // roles={'Masteradmin'}
              permissions={['category-edit']}
            >
              <Tooltip title="แก้ไขข้อมูล">
                <ButtonPrimary
                  onClick={() => navigate(`/backoffice/video_tutorial/edit/${data.id}`, { replace: true })}
                  style={{ width: '38px', height: '38px', padding: 0 }}
                >
                  <EditOutlined />
                </ButtonPrimary>
              </Tooltip>
            </HasAccess>
            {/* <div style={{ marginTop: '10px' }} />
                  <HasAccess
                     permissions={['lottery_type-delete']}
                  >
                     <Tooltip title="ลบข้อมูล">
                        <ButtonDelete
                           onClick={() => deleteData(data.id)}
                           style={{ width: '38px', height: '38px', padding: 0 }}
                        >
                           <DeleteOutlined />
                        </ButtonDelete>
                     </Tooltip>
                  </HasAccess> */}
          </Space>
        );
      },
      // responsive: ['sm'],
    },
  ];

  return (
    <>
      {isMobileView ? (
        <Table
          dataSource={data}
          columns={columns}
          bordered
          loading={isLoading}
          pagination={pagination}
          onChange={onChangePage}
          rowKey="id"
          // size="large"
          // scroll={}
          scroll={{ x: `${widthMobile}`, y: 600 }}
        />
      ) : (
        <Table dataSource={data} columns={columns} bordered loading={isLoading} pagination={pagination} onChange={onChangePage} rowKey="id" />
      )}
    </>
  );
};

export default TableVideoTutorial;

const VideoContainer = styled.div`
  max-height: 150px;
  max-width: 300px;
  overflow: auto;
  padding: 4px;
  background-color: #f8f8f8;
  border: 1px solid #ccc;
  font-size: 13px;
  line-height: 1.4;
  border-radius: 6px;
  word-wrap: break-word;

  // จัดการ iframe (เช่น YouTube embed)
  iframe {
    max-width: 100%;
    height: auto;
  }

  // จัดการ p, span, ฯลฯ
  p {
    margin: 0;
  }
`;
